import React from 'react';

import {DocTableRow} from './DocTableRow';
import {DocTableHeader} from './DocTableHeader';
import {DATA_NOT_AVAILABLE, hasDataInArray, isPresent, mayBe} from '../../containers/doc_view/utils';

import './DocTable.scss';
import {has} from "lodash";

export interface DocTableProps {
    title?: string;
    subtitle?: string;
    headers: string[];
    rows: string[][];
    empty: string;
    className?: string;
    isBoldRow?: (cells: string[], rowIndex: number) => boolean;
}

export const DocTable: React.FC<DocTableProps> = ({
                                                      title = '',
                                                      subtitle = '',
                                                      headers = [],
                                                      rows = [],
                                                      empty = '',
                                                      className = '',
                                                      isBoldRow = () => false,
                                                  }) => {
    const hasHeaders = isPresent(headers);
    const hasRowsData = hasDataInArray(rows);

    return (
            <div className={`doc-table ${className || ''}`}>
                {isPresent(title) && <div className="doc-table__title">{mayBe(title)}</div>}
                {isPresent(subtitle) && <div className="doc-table__subtitle">{mayBe(subtitle)}</div>}
                {hasHeaders && <DocTableHeader headers={headers}/>}
                {hasRowsData &&
                        rows.map((cells, index) => (
                                <DocTableRow key={`key-doc-table-row-${index}`}
                                             cells={cells}
                                             bold={isBoldRow(cells, index)}
                                />
                        ))}
                {!hasRowsData && (
                        <div className="doc-table__no-data">
                            <div className="doc-table__no-data__text">{empty || DATA_NOT_AVAILABLE}</div>
                        </div>
                )}
            </div>
    );
};
